var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvascontainer",staticClass:"bonus-panel-spine",attrs:{"id":'canvas-container-animation-bonus-panel' + _vm.index}})
}
var staticRenderFns = []

export { render, staticRenderFns }